const INTERSETION_THRESHOLD = 0.2;
const SLIDE_IN_DELAY_RATIO = 0.1;

export function slideInWithIntersection(elements) {
  const options = {
    root: null,
    rootMargin: '10px',
    threshold: INTERSETION_THRESHOLD
  }

  let timers = 0;

  const callback = (entries, observer) => {
    entries.forEach(entry => {
      const element = entry.target;

      if (entry.intersectionRatio >= INTERSETION_THRESHOLD) {
        timers++;

        const delay = (Math.max(0, timers - 1) * SLIDE_IN_DELAY_RATIO);

        element.style.setProperty('--td', delay + 's');
        element.classList.add('slide-in');

        setTimeout(() => {
          timers--;
        }, delay);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  for (const [index, element] of Object.entries(elements)) {
    observer.observe(element);
  }
}

export function fadeInWithIntersection(elements) {
  const options = {
    root: null,
    rootMargin: '10px',
    threshold: INTERSETION_THRESHOLD
  }

  let timers = 0;

  const callback = (entries, observer) => {
    entries.forEach(entry => {
      const element = entry.target;

      if (entry.intersectionRatio >= INTERSETION_THRESHOLD) {
        timers++;

        const delay = (Math.max(0, timers - 1) * SLIDE_IN_DELAY_RATIO);

        element.style.setProperty('--td', delay + 's');
        element.classList.add('fade-in');

        setTimeout(() => {
          timers--;
        }, delay);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  for (const [index, element] of Object.entries(elements)) {
    observer.observe(element);
  }
}

export function parallaxEffect(elements) {
  elements.forEach(element => {
    new simpleParallax(element.querySelector('img'));
  });
}
